import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, message} from 'antd';
import {connect} from "react-redux";
import {userActions as authenticationActions} from "../actions/authenticationActions";
import {getAuthenticationFailureMsg} from "../selectors/authentication";

class VerifyAccountForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        if (this.props.authFailureMsg && this.props.authFailureMsg.id) {
          this.props.resendEmail(this.props.authFailureMsg.id);
          message.info(this.context.t('Email successfully sent'))
          this.props.onClose();
        }
      }
    });
  };

  render() {
    return (
      <Fragment>
        <Form className="form-line" layout="vertical">
          <p className="pt-8">
            {this.context.t('To verify your account, please')}
            <Button type="primary"
                    htmlType="button"
                    onClick={this.handleSubmit}
                    className="mx-1 px-2">
              {this.context.t('click here')}
            </Button>
            {this.context.t('and then check your email')}
          </p>
        </Form>
      </Fragment>

    )
  }
}

VerifyAccountForm.propTypes = {
  authFailureMsg: PropTypes.string,
  resendEmail: PropTypes.func
};

VerifyAccountForm.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  authFailureMsg: getAuthenticationFailureMsg(state)
});

const mapDispatchToProps = (dispatch) => ({
  resendEmail: (id) => authenticationActions.resendEmail(id)(dispatch)
});

VerifyAccountForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyAccountForm);

const WrappedRegistrationForm = Form.create({name: 'verifyAccountForm'})(VerifyAccountForm);

export default WrappedRegistrationForm;
